import axios from "axios";
import { clearLogoutData } from "../../logout/action";
import { Documents_Master_Service_URL } from "../../Url";

export const DocumentsMasterActions = {
  GET_DOCUMENTS_MASTER_REQUEST: "GET_DOCUMENTS_MASTER_REQUEST",
  GET_DOCUMENTS_MASTER_LOADING: "GET_DOCUMENTS_MASTER_LOADING",
  GET_DOCUMENTS_MASTER_SUCCESS: "GET_DOCUMENTS_MASTER_SUCCESS",
  GET_DOCUMENTS_MASTER_ERROR: "GET_DOCUMENTS_MASTER_ERROR",
};

export const documentsMaster = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId } = props;
  dispatch(getDocumentsMasterLoading());
  return axios({
    method: "post",
    url: `${Documents_Master_Service_URL}/get/DocumentMasters`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(getDocumentsMasterSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);

        dispatch(getDocumentsMasterError(error));
        throw error;
      }
    })
    .catch((error) => {
      if (error.response.status == 403) {
        dispatch(clearLogoutData());
      } else {
        if (error.response) {
          dispatch(getDocumentsMasterError(error));
        }
      }
    });
};

export function getDocumentsMasterError(error) {
  return {
    type: DocumentsMasterActions.GET_DOCUMENTS_MASTER_ERROR,
    payload: error,
  };
}

export function getDocumentsMasterSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: DocumentsMasterActions.GET_DOCUMENTS_MASTER_SUCCESS,
      payload: props,
    });
  };
}

export function getDocumentsMasterLoading() {
  return {
    type: DocumentsMasterActions.GET_DOCUMENTS_MASTER_LOADING,
  };
}
